 import {
    PLATFORM_DETAILS_SHOW as CRUD_ACTION_SHOW,
    PLATFORM_DETAILS_UPDATE as CRUD_ACTION_UPDATE,
 } from "../../actions/platforms_portal/platform";
 import axioses from "@/axios/config";
 import qs from "qs"
 const routePrefix='details';

 const state = {};

 const getters = {};

 const actions = {
     [CRUD_ACTION_SHOW]: ({ commit, dispatch }, params) => {
         return new Promise((resolve, reject) => {
         commit('START_LOADING', null, { root: true });
         axioses.platformPortal
             .get(`platforms/${routePrefix}`,{ params ,paramsSerializer: params => {return qs.stringify(params, { skipNulls: true, indices: false })}})
             .then(response => {
                 resolve(response);
                 commit('STOP_LOADING', null, { root: true });
             })
             .catch(error => {
                 commit('STOP_LOADING', null, { root: true });
                 reject(error);
             });
         });
     },
    [CRUD_ACTION_UPDATE]: ({ commit, dispatch }, params) => {
        return new Promise((resolve, reject) => {
            commit('START_LOADING', null, { root: true });
            axioses.platformPortal
                .put(`platforms/${routePrefix}`,{...params.data})
                .then(response => {
                    resolve(response);
                    commit('STOP_LOADING', null, { root: true });
                })
                .catch(error => {
                    commit('STOP_LOADING', null, { root: true });
                    reject(error);
                });
        });
    },
 };

 const mutations = {};

 export default {
     state,
     getters,
     actions,
     mutations
 };